// extracted by mini-css-extract-plugin
module.exports = {"editableBackdrop":"EditableNavLink_editableBackdrop__2J6fS"};